import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import StorageMartLanguageMenu from 'containers/StorageMartLanguageMenu';
import StorageMartHeaderSearch from 'containers/StorageMartHeaderSearch';
import StorageMartNavItem from '../StorageMartNavItem';
import useMedia from '../../../../modules/react/hooks/useMedia';
import styles from './styles.scss';

const propTypes = {
  navigation: PropTypes.arrayOf(PropTypes.shape({
    page: PropTypes.shape({
      path: PropTypes.string,
      title: PropTypes.string.isRequired,
    }),
    text: PropTypes.string,
    link: PropTypes.shape({
      target: PropTypes.string,
      href: PropTypes.string,
    }),
    navigationItems: PropTypes.array,
  })),
  onSelect: PropTypes.func,
  hideLanguageMenu: PropTypes.bool,
  closeMobileNav: PropTypes.func,
  navbarClassName: PropTypes.string,
  navItemClassName: PropTypes.string,
};

const defaultProps = {
  navigation: [],
  hideLanguageMenu: undefined,
  navbarClassName: undefined,
  navItemClassName: undefined,
};

const StorageMartNav = ({
  navigation,
  hideLanguageMenu,
  closeMobileNav,
  navbarClassName,
  navItemClassName,
  id,
}) => (
  <>
    {useMedia(
      ['(max-width: 767px)'],
      [
        <div className="w-full bg-white">
          {!hideLanguageMenu && <div className="p-4"><StorageMartLanguageMenu id={id} /></div>}
          <div className="flex items-center w-full p-4 bg-sm-yellow">
            <StorageMartHeaderSearch closeMobileNav={closeMobileNav} id="storageMartNav-search" />
          </div>
        </div>,
      ],
    )}
    <ul
      className={`flex p-0 m-0 list-none max-md:flex-col max-md:bb-4 
        max-md:bg-nav max-md:overflow-hidden md:items-center md:gap-4 ${navbarClassName}`}
    >
      <li className={`flex md:flex-col ${navItemClassName} ${styles.navItemClassNameTest}`} data-all-location="">
        <span
          style={{
            display: 'flex',
            gap: '.25rem',
            flexGrow: '1',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexDirection: 'row',
          }}
        >
          <a href="/find-storage-nearby" className="flex items-center" data-find-storage-nearby>Find Storage Nearby</a>
        </span>
      </li>
      {navigation.map(item => (
        <StorageMartNavItem
          className={`flex md:flex-col ${navItemClassName}`}
          key={item.text || (item.page && item.page.title)}
          item={item}
          closeMobileNav={closeMobileNav}
        />
      ))}
    </ul>
  </>
);

StorageMartNav.propTypes = propTypes;
StorageMartNav.defaultProps = defaultProps;
StorageMartNav.fragments = (() => {
  const page = gql`
    fragment NavigationItemPageFields on Page {
      path
      title
    }
  `;

  const navigationItemFields = gql`
    fragment NavigationItemFields on NavigationItem {
      id
      text
      link {
        href
        target
      }
      page {
        id
        ...NavigationItemPageFields
      }
    }

    ${page}
  `;

  return {
    navigationItem: gql`
      fragment NavigationItems on NavigationItem {
        ...NavigationItemFields
        navigationItems {
          ...NavigationItemFields
          navigationItems {
            ...NavigationItemFields
            navigationItems {
              ...NavigationItemFields
            }
          }
        }
      }

      ${navigationItemFields}
    `,
    page,
  };
})();

export default StorageMartNav;
